var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhisper(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1314",
    d: "M866.839 79.407a1 1 0 0 1-.963-1.276l4-14a1 1 0 0 1 1.923.55l-4 14a1 1 0 0 1-.96.726z",
    transform: "translate(-865.838 -61.406)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1315",
    d: "M875.718 77.4h-.018a1 1 0 0 1-.918-.661l-2.879-8a1 1 0 1 1 1.88-.677l2 5.559 2.3-5.6a1 1 0 0 1 1.865.042l1.95 5.416 2-5.423a1 1 0 0 1 1.877.691l-2.948 8a1 1 0 0 1-.938.654 1 1 0 0 1-.937-.661l-2-5.559-2.3 5.6a1 1 0 0 1-.934.619z",
    transform: "translate(-865.838 -61.406)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhisper);
export default __webpack_public_path__ + "static/media/icon-whisper.a716e113615130fa3fb4b9976c8f2002.svg";
export { ForwardRef as ReactComponent };